import CMSAPI from "../../../../services/api/contentManagmentApi";
import Hero from "../../../home/hero/hero.vue";

const { getHero, updateHero, uploadFile } = new CMSAPI();

export default {
  components: {
    Hero,
  },
  data() {
    return {
      heroDataLoaded: false,
      hero: {},
      options: [
        {
          text: "White",
          value: "white",
        },
        {
          text: "Black",
          value: "black",
        },
      ],
    };
  },
  methods: {
    handleFileUpload,
    handleAddLineClick,
    handleAddCopyClick,
    handleFormSubmit,
    handleFullscreenChange,
  },
  beforeMount() {
    getHero().then((response) => {
      const heroData = response.data[0];
      this.hero = {
        ...heroData,
        h1Array: heroData.h1.split("_%_").map((value, index) => ({
          value: value,
          id: index,
        })),
        by_lineArray: heroData.by_line.split("_%_").map((value, index) => ({
          value: value,
          id: index,
        })),
      };
      this.heroDataLoaded = true;
    });
  },
};

function handleFileUpload(fileName, files) {
  this.$notify.$emit("fire", {
    message: "uploading image..",
    type: "working",
  });
  const formData = new FormData();
  formData.append("file", files[0]);
  uploadFile(formData).then((response) => {
    this.hero[fileName] = response.data.url;
    this.$notify.$emit("update", "Image Upload complete..");
    const timeout = 350;
    setTimeout(() => this.$notify.$emit("close", true), timeout);
  });
}

function handleAddLineClick() {
  this.hero.h1Array.push({
    value: "",
  });
}
function handleAddCopyClick() {
  this.hero.by_lineArray.push({
    value: "",
  });
}
function handleFullscreenChange() {
  this.hero.is_full_screen = !this.hero.is_full_screen;
}
function handleFormSubmit() {
  this.hero.h1Array = this.hero.h1Array.filter((line) => line.value !== "");
  this.hero.h1 = this.hero.h1Array.map((value) => value.value).join("_%_");

  this.hero.by_lineArray = this.hero.by_lineArray.filter((line) => line.value !== "");
  this.hero.by_line = this.hero.by_lineArray.map((value) => value.value).join("_%_");

  const payload = {
    view_components: [
      {
        attributes: {
          image_url: this.hero.image_url,
          mobi_image_url: this.hero.mobi_image_url,
          background_color: this.hero.background_color,
          button_color: this.hero.button_color,
          is_full_screen: this.hero.is_full_screen,
          h1: this.hero.h1,
          by_line: this.hero.by_line,
          url: this.hero.feature.url,
          // FEATURED COLLECTION
          component_type: "COLLECTION",
          homepage_title: this.hero.feature.homepage_title,
          collection_by_line: "collection_by_line",
          button_copy: this.hero.feature.button_copy,
        },
        component_type: "HERO",
        ordinal: 1,
      },
    ],
  };
  updateHero(payload)
    .then(() => this.$swal("Success: Hero Saved"))
    .catch((error) =>
      error.response
        ? this.$swal("Attention", error.response.data.error_message)
        : this.$logger.notify(new Error(error))
    );
}
